'use client'

import { Fragment } from 'react'
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react'
import { ChevronLeft } from 'lucide-react'

export const panelFocusRing = 'focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-foreground'

export default function SidePanel({ open, onClose, title, subtitle, footer, children, className = '' }: { open: boolean, onClose: () => void, title: React.ReactNode, subtitle?: React.ReactNode, footer?: React.ReactNode, children: React.ReactNode, className?: string }) {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <TransitionChild as={Fragment} enter="transition-opacity ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
          <div className="fixed inset-0 bg-foreground/30" />
        </TransitionChild>
        <div className="fixed inset-0 flex justify-end">
          <TransitionChild as={Fragment} enter="transition ease-out duration-300 transform motion-reduce:transition-none" enterFrom="translate-x-full" enterTo="translate-x-0" leave="transition ease-in duration-200 transform motion-reduce:transition-none" leaveFrom="translate-x-0" leaveTo="translate-x-full">
            <DialogPanel className={`flex w-full max-w-lg flex-col bg-background text-foreground ${className}`}>
              <div className="flex justify-end px-6 lg:px-10 pt-6 shrink-0">
                <button type="button" onClick={onClose} className={`inline-flex items-center gap-1.5 text-[13px] transition-opacity duration-150 hover:opacity-60 ${panelFocusRing}`}>
                  <ChevronLeft className="size-4" strokeWidth={1.5} />
                  Буцах
                </button>
              </div>
              <div className="px-6 lg:px-10 pt-4 pb-6 shrink-0">
                <DialogTitle className="text-2xl tracking-tight">{title}</DialogTitle>
                {subtitle && <div className="mt-2">{subtitle}</div>}
              </div>
              <div className="flex-1 overflow-y-auto overscroll-contain px-6 lg:px-10 pb-10">
                {children}
              </div>
              {footer && <div className="shrink-0 border-t border-border px-6 lg:px-10 py-5">{footer}</div>}
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  )
}
